import { render, staticRenderFns } from "./employeeInsuranceSchool.vue?vue&type=template&id=5362bcd0&scoped=true&"
import script from "./employeeInsuranceSchool.vue?vue&type=script&lang=js&"
export * from "./employeeInsuranceSchool.vue?vue&type=script&lang=js&"
import style0 from "./employeeInsuranceSchool.vue?vue&type=style&index=0&id=5362bcd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5362bcd0",
  null
  
)

export default component.exports